import { useState, useEffect } from 'react'
import PlayerService from 'src/service/PlayerService'

const useChartData = () => {
  const [data, setData] = useState([])
  const [wksRangeData, setWksRangeData] = useState([])
  const [foursRangeData, setFoursRangeData] = useState([])
  const [sixesData, setSixesData] = useState([])
  const [mdnsData, setMdnsData] = useState([])

  const [twData, setTwData] = useState([])
  const [psData, setPsData] = useState([])
  const [pmData, setPmData] = useState([])
  const [gcdData, setGcdData] = useState([])
  const [ycdData, setYcdData] = useState([])
  const [rcdData, setRcdData] = useState([])
  const [cstData, setCstData] = useState([])
  const [p60Data, setP60Data] = useState([])
  const [p60PlusData, setP60PlusData] = useState([])

  const [fpsData, setFpsData] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    PlayerService.getPlayerPieChartValue().then((res) => {
      setLoading(true)
      if (res.status === 200) {
        setData(res.data)
        setWksRangeData(res.wksRangeData)
        setFoursRangeData(res.foursRangeData)
        setSixesData(res.sixesRangeData)
        setMdnsData(res.mdnsRangeData)

        setTwData(res.twData)
        setPsData(res.psData)
        setPmData(res.pmData)
        setGcdData(res.gcdData)
        setYcdData(res.ycdData)
        setRcdData(res.rcdData)
        setCstData(res.cstData)
        setP60Data(res.p60Data)
        setP60PlusData(res.p60PlusData)

        setFpsData(res.fpRangeData)
        setLoading(false)
      }
    })
  }, [])

  const dataValues = Object.values(data).map((value) => parseInt(value, 10))
  const dataWksValues = Object.values(wksRangeData).map((value) => parseInt(value, 10))
  const dataFoursValues = Object.values(foursRangeData).map((value) => parseInt(value, 10))
  const dataSixesValues = Object.values(sixesData).map((value) => parseInt(value, 10))
  const dataMdnsValues = Object.values(mdnsData).map((value) => parseInt(value, 10))
  const dataFpValues = Object.values(fpsData).map((value) => parseInt(value, 10))
  const dataTwValues = Object.values(twData).map((value) => parseInt(value, 10))
  const dataPsValues = Object.values(twData).map((value) => parseInt(value, 10))
  const dataPmValues = Object.values(twData).map((value) => parseInt(value, 10))
  const dataGcdValues = Object.values(twData).map((value) => parseInt(value, 10))
  const dataYcdValues = Object.values(twData).map((value) => parseInt(value, 10))
  const dataRcdValues = Object.values(twData).map((value) => parseInt(value, 10))
  const dataCstValues = Object.values(twData).map((value) => parseInt(value, 10))
  const dataP60Values = Object.values(twData).map((value) => parseInt(value, 10))
  const dataP60PlusValues = Object.values(twData).map((value) => parseInt(value, 10))

  const formattedData = {
    labels: ['1', '2', '3', '4', '5', '6', '7', '8+ '],
    datasets: [
      {
        label: 'Goal Per Match',
        backgroundColor: '#FF6384',
        data: dataValues,
      },
    ],
  }

  const formattedWksData = {
    labels: ['1', '2', '3', '4', '5', '6', '7', '8+ '],
    datasets: [
      {
        label: 'Goal Saves Per match',
        backgroundColor: '#36A2EB',
        data: dataWksValues,
      },
    ],
  }

  const formattedFourData = {
    labels: ['1', '2', '3', '4', '5', '6', '7', '8+ '],
    datasets: [
      {
        label: 'Own Goal Per Match',
        backgroundColor: '#4BC0C0',
        data: dataFoursValues,
      },
    ],
  }

  const formattedSixesData = {
    labels: ['1', '2', '3', '4', '5', '6', '7', '8+ '],
    datasets: [
      {
        label: 'Assists Per Match',
        backgroundColor: '#36A2EB',
        data: dataSixesValues,
      },
    ],
  }

  const formattedMdnsData = {
    labels: ['1', '2', '3', '4', '5', '6', '7', '8+ '],
    datasets: [
      {
        label: 'Passes Intercepted Per Match',
        backgroundColor: '#4BC0C0',
        data: dataMdnsValues,
      },
    ],
  }

  const formattedFpData = {
    labels: ['1-5', '6-10', '11-15', '16-20', '21-30', '31-40', '41-50', '51+'],
    datasets: [
      {
        label: 'Fantasy Points Per Inning',
        backgroundColor: '#36A2EB',
        data: dataFpValues,
      },
    ],
  }

  const formattedTwData = {
    labels: ['1', '2', '3', '4', '5', '6', '7', '8+ '],
    datasets: [
      {
        label: 'Tackles Won Per Match',
        backgroundColor: '#4BC0C0',
        data: dataTwValues,
      },
    ],
  }
  const formattedPsData = {
    labels: ['1', '2', '3', '4', '5', '6', '7', '8+ '],
    datasets: [
      {
        label: 'Penalty Saves Per Match',
        backgroundColor: '#4BC0C0',
        data: dataPsValues,
      },
    ],
  }
  const formattedPmData = {
    labels: ['1', '2', '3', '4', '5', '6', '7', '8+ '],
    datasets: [
      {
        label: 'Penalty Miss Per Match',
        backgroundColor: '#4BC0C0',
        data: dataPmValues,
      },
    ],
  }
  const formattedGcdData = {
    labels: ['1', '2', '3', '4', '5', '6', '7', '8+ '],
    datasets: [
      {
        label: 'Green Card Per Match',
        backgroundColor: '#4BC0C0',
        data: dataGcdValues,
      },
    ],
  }
  const formattedYcdData = {
    labels: ['1', '2', '3', '4', '5', '6', '7', '8+ '],
    datasets: [
      {
        label: 'Yellow Card Per Match',
        backgroundColor: '#4BC0C0',
        data: dataYcdValues,
      },
    ],
  }
  const formattedRcdData = {
    labels: ['1', '2', '3', '4', '5', '6', '7', '8+ '],
    datasets: [
      {
        label: 'Red Card Per Match',
        backgroundColor: '#4BC0C0',
        data: dataRcdValues,
      },
    ],
  }
  const formattedCstData = {
    labels: ['1', '2', '3', '4', '5', '6', '7', '8+ '],
    datasets: [
      {
        label: 'Clean Sheet Per Match',
        backgroundColor: '#4BC0C0',
        data: dataCstValues,
      },
    ],
  }
  const formattedP60Data = {
    labels: ['1', '2', '3', '4', '5', '6', '7', '8+ '],
    datasets: [
      {
        label: 'Played 60mins Per Match',
        backgroundColor: '#4BC0C0',
        data: dataP60Values,
      },
    ],
  }
  const formattedP60PlusData = {
    labels: ['1', '2', '3', '4', '5', '6', '7', '8+ '],
    datasets: [
      {
        label: 'Played 60mins Plus Per Match',
        backgroundColor: '#4BC0C0',
        data: dataP60PlusValues,
      },
    ],
  }

  return {
    loading,
    formattedData,
    formattedWksData,
    formattedFourData,
    formattedSixesData,
    formattedMdnsData,
    formattedFpData,
    formattedTwData,
    formattedPsData,
    formattedPmData,
    formattedGcdData,
    formattedYcdData,
    formattedRcdData,
    formattedCstData,
    formattedP60Data,
    formattedP60PlusData,
  }
}

export default useChartData
